module.exports = __webpack_public_path__ + "img/1.fb9e2255.png";